module.exports = __webpack_public_path__ + "static/SyneMono-Regular-9c4e7f2c1b4b76bf12d6c1a177ee7e94.ttf";